var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWorksheetIcon = function SvgWorksheetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.597 13.744h1.049c.587 0 .877.712.461 1.128L16.08 17.9a.657.657 0 0 1-.93 0l-3.029-3.028a.662.662 0 0 1 .469-1.128h1.049v-3.299c0-.362.297-.66.66-.66h2.638c.363 0 .66.298.66.66v3.299ZM11.66 21a.662.662 0 0 1-.66-.66c0-.363.297-.66.66-.66h7.916c.362 0 .66.297.66.66 0 .363-.298.66-.66.66H11.66Z",
    fill: "#797CDB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v5.5h-3a1 1 0 0 0-1 1v3.472h-.622c-.841 0-1.267 1.021-.671 1.617l.41.411H4a1 1 0 0 1-1-1V3Zm2 1.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-1ZM5.5 8a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5H9a.5.5 0 0 0 .5-.5v-1A.5.5 0 0 0 9 8H5.5Z",
    fill: "#797CDB"
  })));
};
export default SvgWorksheetIcon;